module.exports = __webpack_public_path__ + "static/img/FITmenu08.4fe34d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/FITmenu08.png
// module id = DhXZ
// module chunks = 1